import { render, staticRenderFns } from "./PhotoFeedView.vue?vue&type=template&id=922d4b12&scoped=true"
import script from "./PhotoFeedView.vue?vue&type=script&lang=js"
export * from "./PhotoFeedView.vue?vue&type=script&lang=js"
import style0 from "./PhotoFeedView.vue?vue&type=style&index=0&id=922d4b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922d4b12",
  null
  
)

export default component.exports